import { Params } from '@angular/router';
import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import { FilterParams } from './router.models';
import { CustomRouterState } from './router.serializer';

const selectFeature = createFeatureSelector<RouterReducerState<CustomRouterState>>('router');

export const selectUrl = createSelector(selectFeature, (state) => state.state?.url);
export const selectFilterParams = createIsEqualSelector(selectFeature, (state) => {
    if (state.state?.queryParams) {
        return new FilterParams(state.state?.queryParams);
    }
    return undefined;
});
export const selectParams = createIsEqualSelector(selectFeature, (state) => state.state?.params);
export const selectRouterState = createIsEqualSelector(
    selectUrl,
    selectParams,
    selectFilterParams,
    (url: string, params: Params, filterParams: FilterParams) => ({ url, params, filterParams })
);
